import utils from '../utils/utils'
import anime from '../libs/anime'
import globalVar from '../utils/globalVar'

class Module02Intro {
  constructor() {
      let cache = {};
      let scrollPos = window.pageYOffset;
      let imgArray = [];
      let randImgArray = [];
      let sizeW = 0;
      let sizeH = 0;
      let gap = 0;
      const nbRow = 6;
      let initFunc = () => {
        initCache();
        resize();
        window.onresize = resize;
        scrollDetect();
        window.addEventListener('scroll', scrollDetect);
      }
  
      let initCache = () => {
        cache.intro = document.querySelector('.module-02_intro.intro-anime');
        cache.secTransition = document.querySelector('.transition-intro_container');
        cache.transition = cache.secTransition.querySelector('.transition_intro');
        cache.img1 = cache.secTransition.querySelector('.img_sample1');
        cache.img2 = cache.secTransition.querySelector('.img_sample2');
        if(cache.intro.nextElementSibling.classList.contains('bg_white')) {
            cache.img1 = cache.secTransition.querySelector('.img_sample1_white');
        }
      };

      let resize = () => {
        imgArray = [];
        cache.transition.innerHTML = "";
        if(globalVar.desktop.matches) {
            sizeW = 73;
            sizeH = 78;
            gap = 35;
        }
        else {
            sizeW = 38;
            sizeH = 40;
            gap = 20;
        }
        initImg();
      };

      let initImg = () => {
        const nbImg = ((Math.ceil(window.innerWidth/(sizeW+gap)))*2)+2;
        for (let iRow = 0; iRow < nbRow; iRow++) {
            let div = document.createElement('div');
            div.classList.add('row');
            for (let iImg = 0; iImg < nbImg; iImg++) {
                if(iRow % 2) {
                    let img = document.createElement('img');
                    if(iImg % 2) {
                        img.src = cache.img2.src;
                        img.classList.add('img_odd');
                    } else {
                        img.src = cache.img1.src;
                    }
                    img.classList.add('row_odd'); 
                    div.appendChild(img);
                } else {
                    let img = document.createElement('img');
                    if(iImg % 2) {
                        img.src = cache.img1.src;
                        img.classList.add('img_odd');
                    } else {
                        img.src = cache.img2.src;
                    }
                    div.appendChild(img);
                }
            }
            cache.transition.appendChild(div);
        }

        imgArray = Array.from(document.querySelectorAll('.module-02_intro.intro-anime .transition-intro_container .transition_intro img'));
        randImgArray = shuffle(imgArray);
        
      };

      let scrollDetect = function() {
        scrollPos = window.pageYOffset;

        if(((scrollPos + window.innerHeight) > (cache.intro.offsetTop + cache.intro.offsetHeight)) && ((scrollPos + window.innerHeight) < ((cache.intro.offsetTop + cache.intro.offsetHeight) + cache.secTransition.offsetHeight)) ) {
            let pos = ( ((scrollPos + window.innerHeight)-(cache.intro.offsetTop + cache.intro.offsetHeight)) / (cache.secTransition.offsetHeight));
            for (let i = randImgArray.length-1; i >= 0; i--) {
                let lineInnerAnime =  anime({
                    targets: randImgArray[i],
                    opacity: [1,0],
                    delay: 10 * i,
                    duration: 1000,
                    easing: 'linear',
                    autoplay: false,
                }) 
            
                lineInnerAnime.seek((pos *(1 + i/100)+0.01) * lineInnerAnime.duration);
                            
            }
        }

        if(((scrollPos + window.innerHeight) < (cache.intro.offsetTop + cache.intro.offsetHeight)) && (cache.transition.classList.contains('completed'))) {
            cache.transition.classList.remove('completed');
            randImgArray.forEach(img => {
                anime({
                    targets: img,
                    opacity: 1,
                    duration: 300,
                    easing: 'linear',
                }) 
            });
        }
        
        if(((scrollPos + window.innerHeight) > ((cache.intro.offsetTop + cache.intro.offsetHeight) + cache.secTransition.offsetHeight)) && (!cache.transition.classList.contains('completed'))) {
            cache.transition.classList.add('completed');
            cache.transition.classList.add('completed-mobile');
            randImgArray.forEach(img => {
                anime({
                    targets: img,
                    opacity: 0,
                    duration: 300,
                    easing: 'linear',
                }) 
            });
        }
        
      }



      function shuffle(array) {
            let currentIndex = array.length,  randomIndex;
    
            // While there remain elements to shuffle...
            while (currentIndex != 0) {
    
            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;
    
            // And swap it with the current element.
            [array[currentIndex], array[randomIndex]] = [
                array[randomIndex], array[currentIndex]];
            }
    
            return array;
        }
    initFunc();
  };
}
export { Module02Intro }
